// Tema del libro de marca Molantur. Por ahora solo lo usa el portal de aliados (/ally): los
// componentes de components/allies/ui lo importan directo, sin ThemeProvider, así seller y admin
// siguen con styles/theme.ts sin enterarse.

const molanturTheme = {
  color: {
    primary: '#C8AC94',      // Adobe
    primaryDeep: '#8C6F55',
    primarySoft: '#F0E5D9',
    onPrimary: '#2B2620',
    sol: '#E6C8A5',          // Sol de tarde
    success: '#55684A',      // Ricarica (deep)
    successBase: '#7A9068',
    successSoft: '#E4EADC',
    warn: '#A86A2C',
    warnSoft: '#F5E6D3',
    danger: '#A8402F',
    ink: '#2B2620',          // Negro nocturno
    inkSoft: '#665B4F',
    inkFaint: '#9C8E7E',
    bg: '#F4ECE2',
    surface: '#FFFFFF',
    surface2: '#FAF5EF',
    line: 'rgba(43,38,32,0.10)',
    lineStrong: 'rgba(43,38,32,0.18)',
  },
  font: {
    display: '"beaufort-pro", Georgia, serif',
    label: '"Jost", system-ui, sans-serif',
    text: '"Poppins", system-ui, sans-serif',
  },
  radius: { lg: '22px', md: '14px', sm: '10px', pill: '999px' },
  shadow: {
    card: '0 4px 14px -6px rgba(43,38,32,0.20)',
    float: '0 10px 30px -12px rgba(43,38,32,0.28)',
    modal: '0 30px 80px -20px rgba(0,0,0,0.5)',
  },
  // Bajo este ancho el portal usa el layout de celular.
  breakpoint: { desktop: '900px' },
  // Degradado por tour (cuadro del pictograma)
  tones: {
    luna:       ['#C8AC94', '#8C6F55'],
    tatio:      ['#6B6F72', '#3A3631'],
    baltinache: ['#7A9068', '#4E6042'],
    piedras:    ['#B07A5E', '#7A4A35'],
    cejar:      ['#8FA59A', '#55706A'],
    arcoiris:   ['#D9B88F', '#A07C55'],
    astro:      ['#3E3832', '#1C1915'],
    uyuni:      ['#3E3832', '#1C1915'],
    ticket:     ['#B9A48F', '#7D6A58'],
  } as Record<string, [string, string]>,
}

export default molanturTheme
export type MolanturTheme = typeof molanturTheme

export const desktop = `@media (min-width: ${molanturTheme.breakpoint.desktop})`
